var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoreWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2343 6.99833C16.4543 6.99833 16.6743 7.05333 16.876 7.16333L23.5676 11.0317C23.9526 11.2517 24.2093 11.6733 24.2093 12.1317V19.8683C24.2093 20.3267 23.971 20.7483 23.5676 20.9683L16.8576 24.8367C16.6743 24.9467 16.4543 25.0017 16.216 25.0017C15.996 25.0017 15.776 24.9467 15.5743 24.8367L8.90096 20.9683C8.51596 20.7483 8.2593 20.3267 8.2593 19.8683V12.1317C8.2593 11.6733 8.49763 11.2517 8.90096 11.0317L15.611 7.16333C15.7943 7.05333 16.0143 6.99833 16.2343 6.99833ZM16.2343 5C15.666 5 15.116 5.14667 14.6026 5.44L7.91096 9.30833C6.90263 9.895 6.2793 10.9583 6.2793 12.1317V19.8683C6.2793 21.0417 6.90263 22.105 7.91096 22.6917L14.621 26.56C15.1343 26.8533 15.6843 27 16.2526 27C16.821 27 17.371 26.8533 17.8843 26.56L24.5943 22.6917C25.6026 22.105 26.226 21.0417 26.226 19.8683V12.1317C26.226 10.9583 25.6026 9.895 24.5943 9.30833L17.866 5.44C17.371 5.14667 16.8026 5 16.2343 5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoreWhite);
export default __webpack_public_path__ + "static/media/core-white.6fd9fd940c0700d1d3a3e96b88c6e527.svg";
export { ForwardRef as ReactComponent };